<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
        <v-col class="pa-0">
            <hr-employee-chain :id="id" class="mx-2"></hr-employee-chain>
            <show v-if="Object.keys(models).length"
                :id="id"
                model-def="hremployees"
                model-class="hremployee"
                :models="models"
                :infos="infos"
                :activities="true"
                :maillogs="false"
                :fileuploader="true">
            </show>
        </v-col>
    </v-row>
</template>

<script>
    import HrEmployeeChain from './HrEmployeeChain'

    export default {
        name: 'hremployee',
        components: { HrEmployeeChain },

        props: {
            id: Number,
        },

        data() {
            return {
                infos: {},
                models: {},
            }
        },

        methods: {
            initialization() {
                this.axios.get('hremployees/' + this.id).then(response => {
                    this.$set(this, 'models', response.data.models)
                    this.$set(this, 'infos', response.data.infos)
                    this.$store.commit('endProgress')
                }, response => {
                    // error callback
                })
            }
        },

        created() {
            this.initialization()
        },
    }
</script>
